import { Maybe } from "graphql";

import { StrapiImage } from "ui/StrapiImage";
import { useI18n } from "utils/with-i18n.utils";

import { CatalogProductCard } from "../CatalogProductCard";

type CatalogProductCardComingSoonProps = {
  brand: string;
  slug: string;
  modelName: string;
  image: {
    alternativeText: Maybe<string>;
    name?: string;
    medium?: string;
    thumbnail?: string;
  };
  releaseDate: string;
};

export const CatalogProductCardComingSoon = ({
  brand,
  slug,
  modelName,
  image,
  releaseDate,
}: CatalogProductCardComingSoonProps) => {
  const i18n = useI18n();

  return (
   <CatalogProductCard type="coming-soon" tag="custom-coming-soon" href={`/smartphone${slug}`}>
      {/* Infos */}
      <div className="flex-1 py-5 w-full max-w-[240px] xs:py-0 xs:px-5">
        <p className="text-sm sm:text-base">{brand}</p>
        <p className="text-lg font-semibold tracking-tighter sm:text-2xl">{modelName}</p>

        <div className="items-center mt-2 w-full text-sm xs:hidden">
          <p>{i18n.t('catalog.comingSoon.availability')}</p>
          <p className="text-2xl font-semibold text-cornflower-blue">{releaseDate}</p>
        </div>
      </div>

      {/* Image */}
      <StrapiImage
        image={{
          alternativeText: image.alternativeText,
          medium: { url: image.medium, name: image.name },
          thumbnail: { url: image.thumbnail, name: image.name },
        }}
        size="medium"
        sizes="40vw"
        className="ml-5 w-[92px] h-[120px] sm:w-[165px] sm:h-[165px] xs:ml-0"
      />

      {/* Release date */}
      <div className="hidden flex-col items-center text-sm sm:text-base xs:flex">
          <p>{i18n.t('catalog.comingSoon.availability')}</p>
        <p className="text-2xl font-semibold text-cornflower-blue sm:text-3xl">{releaseDate}</p>
      </div>
    </CatalogProductCard>
  );
};
